import { render, staticRenderFns } from "./RecordFeeDetailModal.vue?vue&type=template&id=bcb632ca"
import script from "./RecordFeeDetailModal.vue?vue&type=script&lang=js"
export * from "./RecordFeeDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports